import React, { useEffect, useRef, useState } from "react";
import { StyledGoal, StyledGoalLetter, StyledGoalWrapper } from "./StyledGoal";
import { StyledScoreBug } from "../../StyledScorebug";

const ANIMATION_DURATION_IN_MS = 21000;

function Goal({ homeDisplay, awayDisplay }) {
  const [isGoal, setIsGoal] = useState(false);
  const firstRender = useRef(true);
  const goalAnimationTimeout = useRef(null);

  useEffect(() => {
    if (Number(homeDisplay) === 0 && Number(awayDisplay) === 0) return;

    if (firstRender.current) {
      firstRender.current = false;
    } else if (!goalAnimationTimeout.current) {
      setIsGoal(true);
      goalAnimationTimeout.current = setTimeout(() => {
        setIsGoal(false);
        goalAnimationTimeout.current = null;
      }, ANIMATION_DURATION_IN_MS);
    }
  }, [homeDisplay, awayDisplay]);


  return (
    <StyledGoal className={`mls-c-scorebug__goal ${isGoal ? "--is-goal" : ""}`}>
      <StyledScoreBug className="mls-c-scorebug__wrapper">
        <span className="mls-c-scorebug__score">{homeDisplay}</span>
        <span className="mls-c-scorebug__separator" />
        <span className="mls-c-scorebug__score">{awayDisplay}</span>
      </StyledScoreBug>
      <StyledGoalWrapper className="goal-anim">
        <StyledGoalLetter>G</StyledGoalLetter>
        <StyledGoalLetter>O</StyledGoalLetter>
        <StyledGoalLetter>A</StyledGoalLetter>
        <StyledGoalLetter>L</StyledGoalLetter>
      </StyledGoalWrapper>
    </StyledGoal>
  );
}

export default React.memo(Goal);
